import styled from 'styled-components';

export const InventoryItemPanelContainer = styled.div`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    height: 80px;
    justify-content: space-between;
    width: 100%;
    padding: 16px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);
    
`;

export const ItemTitle = styled.h4`
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StatRow = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    align-items: center;
    justify-items: space-between;
    text-align: center;
`;

export const Stat = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 12px;
    align-items: center;
    min-width: 100px;
`;

export const StatLabel = styled.span`
    color: rgba(255, 255, 255, 0.6);
    font-size: 11px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
`;

export const StatValue = styled.span`
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 600;
`;


export const RightContainer = styled.div`
    display: flex;
    gap: 16px;
    justify-content: flex-end;
`;